// POS ödeme dağılımı yardımcıları.

// Ciro düzeltmesi sınıfları (gerçek ödeme kanalı değil; backend satir_sinifi)
const DUZELTME_SINIFLARI = new Set(['INDIRIM', 'ODENMEYEN', 'IKRAM']);

/**
 * Aynı ödeme tipindeki satırları tek satırda toplar (örn. çok sayıda
 * "---İŞLETME İKRAM" → tek satır). Tutara göre azalan sıralı döner.
 * satir_sinifi korunur (NULL/legacy → KANAL sayılır).
 *
 * @param {Array<{odeme_tipi: string, tutar: number, satir_sinifi?: string}>} odemeler
 * @returns {Array<{odeme_tipi: string, tutar: number, satir_sinifi: string}>}
 */
export function aggregateOdemeler(odemeler) {
  if (!Array.isArray(odemeler)) return [];
  const map = {};
  for (const o of odemeler) {
    const tip = (o.odeme_tipi || '').trim();
    const sinif = o.satir_sinifi || 'KANAL';
    const key = `${sinif}|${tip}`;
    if (!map[key]) map[key] = { odeme_tipi: tip, tutar: 0, satir_sinifi: sinif };
    map[key].tutar += (o.tutar || 0);
  }
  return Object.values(map).sort((a, b) => b.tutar - a.tutar);
}

/**
 * Ödeme satırlarını kanal / ciro-düzeltmesi / cari kişi detayı olarak ayırır.
 * Kanal yüzdeleri yalnız kanallar üzerinden hesaplanmalı; düzeltmeler
 * (İNDİRİM/ÖDENMEZ/İKRAM) bilgilendirme amaçlı ayrı gösterilir.
 * CARI_DETAY = ***<kişi> veresiye kırılımı: tutarı ebeveyn CARİ satırında
 * zaten var — kanal sayılırsa çift sayım olur, ayrı grupta döner.
 */
export function splitOdemeler(aggOdemeler) {
  const kanallar = [];
  const duzeltmeler = [];
  const cariDetay = [];
  for (const o of aggOdemeler) {
    if (o.satir_sinifi === 'CARI_DETAY') cariDetay.push(o);
    else if (DUZELTME_SINIFLARI.has(o.satir_sinifi)) duzeltmeler.push(o);
    else kanallar.push(o);
  }
  return { kanallar, duzeltmeler, cariDetay };
}
